import type { PromotionEntry } from '@common/types/promotions';

/** Defaults first; remote entries override by key and fill gaps CDN has not shipped yet. */
export function mergePromotionSources(
  defaults: PromotionEntry[],
  remote: PromotionEntry[],
): PromotionEntry[] {
  const byKey = new Map(defaults.map((item) => [item.key, item]));

  remote.forEach((item) => {
    byKey.set(item.key, item);
  });

  return Array.from(byKey.values());
}
